import { SelectAsync } from '@core/components/Select';
import financeiroApi from 'app/services/api/financeiroApi';
import React from 'react';

const fetchByValue = async (id, idObject, api, value, setSelected, handleChange) => {
  const response = await financeiroApi.get(`${api}/${value}?nome=${value}`);
  if (response.status === 200) {
    handleChange({ target: { id: idObject, value: response.data } });
    setSelected(response.data);
  }
};

const SelectMunicipio = ({
  id,
  idObject = 'pessoa.endereco.cidade',
  handleChange,
  value,
  readOnly,
  handleBlur,
  error,
  touched,
}) => {
  return (
    <SelectAsync
      id={id}
      label="Município"
      api="/api/v1/backend/municipio"
      name="nome"
      handleChange={handleChange}
      handleBlur={handleBlur}
      error={error}
      touched={touched}
      value={value}
      readOnly={readOnly}
      idObject={idObject}
      fetchByValue={fetchByValue}
    />
  );
};

export default SelectMunicipio;
